var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("mds-alert", {
    attrs: {
      title: "Login error",
      text: "The login information are incorrect.",
      variation: "error",
      size: "small",
      tinted: "true",
      dismissible: "false"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }